import React from 'react';

import { Button, Card, CardContent, CardHeader, Divider } from '@mui/material';

export const StrategyDataSection: React.FC = () => {
  return (
    <Card>
      <CardHeader title="Точность следования" />
      <Divider />
      <CardContent>
        <Button variant="contained" aria-label="Рассчитать" onClick={() => {}}>
          Рассчитать
        </Button>
      </CardContent>
    </Card>
  );
};
